import * as Sentry from '@sentry/vue';

// Called by boot.ts, and again by app.ts in case boot.ts failed to load, so the app never
// runs without Sentry. The Vue integration needs the app instance, so app.ts adds it in
// setup() once it exists.
export const startErrorReporting = (): void => {
  if (Sentry.getClient()) {
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    environment: import.meta.env.MODE,
    integrations: (integrations) => integrations.filter((integration) => integration.name !== 'Vue'),
  });
};
